/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plot GC skew (G−C)/(G+C) along a DNA sequence with cumulative skew.`)
};

const es_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafica el sesgo GC (G−C)/(G+C) a lo largo de una secuencia de ADN con sesgo acumulado.`)
};

const de_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plotten Sie den GC-Skew (G−C)/(G+C) entlang einer DNA-Sequenz mit kumulativem Skew.`)
};

const nl_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plot GC-skew (G−C)/(G+C) langs een DNA-sequentie met cumulatieve skew.`)
};

const fr_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracez le biais GC (G−C)/(G+C) le long d'une séquence d'ADN avec le biais cumulé.`)
};

const it_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia lo skew GC (G−C)/(G+C) lungo una sequenza di DNA con lo skew cumulativo.`)
};

const pt_br2_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plote o GC skew (G−C)/(G+C) ao longo de uma sequência de DNA com skew acumulado.`)
};

const pt_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Represente graficamente a assimetria GC (G−C)/(G+C) ao longo de uma sequência de ADN com assimetria cumulativa.`)
};

const ja_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA配列に沿ったGCスキュー (G−C)/(G+C) を累積スキューとともにプロットします。`)
};

const zh_gcskew_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沿 DNA 序列绘制 GC 偏斜 (G−C)/(G+C) 及其累积偏斜。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_tool_description", locale)
	if (locale === "en") return en_gcskew_tool_description(inputs)
	if (locale === "es") return es_gcskew_tool_description(inputs)
	if (locale === "de") return de_gcskew_tool_description(inputs)
	if (locale === "nl") return nl_gcskew_tool_description(inputs)
	if (locale === "fr") return fr_gcskew_tool_description(inputs)
	if (locale === "it") return it_gcskew_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_tool_description(inputs)
	if (locale === "pt") return pt_gcskew_tool_description(inputs)
	if (locale === "ja") return ja_gcskew_tool_description(inputs)
	return zh_gcskew_tool_description(inputs)
};